import { Close, Favorite, FavoriteBorderOutlined } from "@mui/icons-material";
import { Box, Chip, Typography } from "@mui/material";
import React, { useRef } from "react";
import ConfettiButton from "../../../../../../../components/common/Confetti";
import { useTheme } from "../../../../../../../context/themeContext";
import useDiscover from "../../../../../../../hooks/useDiscover";
import useManageProjects from "../../../../../../../hooks/useManageProjects";
import styles from "./style.module.css";
import axios from "axios";
import { node_server } from "../../../../../../../constants";

const Top = ({
	name,
	nickName,
	image,
	label,
	project,
	isFavorite,
	setIsFavorite,
	showConfetti,
	setShowConfetti,
	addToFavorite,
}) => {
	const { theme } = useTheme();
	const { handleCloseProject } = useDiscover(true);
	const { handleFavorite } = useManageProjects();
	const containerRef = useRef(null);

	const removeFromFavorite = async (id) => {
		setIsFavorite(false);
		handleFavorite(id, "remove");

		const response = await axios.post(
			`${node_server}/api/project-feed/${project.project_id}`,
			{
				is_favourite: false,
			},
			{
				withCredentials: true,
			},
		);
		if (response.status !== 200) {
			console.error("Error updating project feed:", response.data);
		}
	};

	return (
		<Box className={styles.top}>
			<Box className={styles.profile}>
				<Box
					className={styles.image}
					sx={{
						backgroundImage: `url(${image})`,
						width: "48px",
						height: "48px",
						backgroundSize: "cover",
						backgroundRepeat: "no-repeat",
						backgroundPosition: "center center",
					}}
				></Box>
				<Box className={styles.name}>
					<Typography
						variant="h6"
						sx={{
							color: theme.palette.darkgrey.darkgrey600,
							display: "-webkit-box",
							WebkitBoxOrient: "vertical",
							overflow: "hidden",
							WebkitLineClamp: 1,
							textOverflow: "ellipsis",
						}}
					>
						{name}
					</Typography>
					<Typography
						variant="body2"
						sx={{
							color: theme.palette.darkgrey.darkgrey300,
						}}
					>
						{nickName}
					</Typography>
				</Box>
				<Box className={styles.options}>
					<Chip
						label={label}
						sx={{
							bgcolor:
								(label === "Brand" && "#EC7508") ||
								(label === "Cause" && "#05B240") ||
								(label === "Creator" && "#09B999") ||
								(label === "Media" && "#B90988"),
							color: "#FFF",
							fontSize: "12px",
							p: "4px 12px",
							"& .css-193rxqu-MuiChip-label": {
								lineHeight: "inherit",
							},
							height: "auto",
						}}
					/>
					<Box
						ref={containerRef}
						sx={{
							position: "relative",
							display: "flex",
							alignItems: "center",
						}}
					>
						<ConfettiButton
							showConfetti={showConfetti}
							setShowConfetti={setShowConfetti}
							containerRef={containerRef}
						/>
						{isFavorite ? (
							<Favorite
								sx={{ fill: theme.palette.primary.main }}
								onClick={() => {
									removeFromFavorite(project.project_id);
								}}
							/>
						) : (
							<FavoriteBorderOutlined
								sx={{ fill: theme.palette.primary.main }}
								onClick={() => {
									addToFavorite(project.project_id);
								}}
							/>
						)}
					</Box>
					<Close
						onClick={() => handleCloseProject(project)}
						sx={{
							color: theme.palette.darkgrey.darkgrey400,
							cursor: "pointer",
						}}
					/>
				</Box>
			</Box>
		</Box>
	);
};

export default Top;
